import { useState, useEffect } from 'react';
import { STORAGE_KEYS } from '../constants/Config';

/**
 * Hook para verificar se há um chat ativo (com mensagens)
 */
export const useChatActive = () => {
  const [isActive, setIsActive] = useState(false);

  const checkChatActive = () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEYS.CHAT_MESSAGES);
      if (stored) {
        const parsed = JSON.parse(stored);
        setIsActive(Array.isArray(parsed) && parsed.length > 0);
      } else {
        setIsActive(false);
      }
    } catch (error) {
      setIsActive(false);
    }
  };

  useEffect(() => {
    // Verificar inicialmente
    checkChatActive();

    // Listener para mudanças no storage (de outras abas)
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === STORAGE_KEYS.CHAT_MESSAGES) {
        checkChatActive();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Polling para detectar mudanças na mesma aba
    const interval = setInterval(checkChatActive, 1000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  return isActive;
};
